<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <top-nav :page_title="page_title" v-bind:search_query="search"></top-nav><br><br>
        <FlashMessage :position="'right bottom'"></FlashMessage>
        <table class="table table-hover">
          <thead class="blue-gradient white-text">
          <tr>
            <th scope="col"><em><b>ID</b></em></th>
            <th scope="col"><em><b>REQUESTER</b></em></th>
            <th scope="col"><em><b>SAMPLE CODE</b></em></th>
            <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
            <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
            <th scope="col"><em><b>PROJECT</b></em></th>
            <th scope="col"><em><b>AVAILABLE AMOUNT</b></em></th>
            <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
            <th scope="col"><em><b>APPROVED AMOUNT</b></em></th>
          </tr>
          </thead>
          <tbody>
          <tr :key="sample.id" v-for="(sample, index) in this.batchSamples">
            <td> {{ index + 1 }}</td>

            <!-- requester details -->
            <td v-if="sample['requester.email']">
              {{ sample['requester.first_name'] + " " + sample['requester.last_name']}}
              <a :href="`mailto:${sample['requester.email']}`" target="_blank">
                <b-icon
                    v-b-tooltip.hover
                    :font-scale="`${font_scale}`"
                    :title="`Contact requester (${ sample['requester.email'] })`" class="border border-info rounded"
                    icon="envelope" variant="info"
                ></b-icon>
              </a>
            </td>
            <td v-else></td>

            <td v-if="sample['requested_sample.code']"> {{ sample['requested_sample.code'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.animal_species']"> {{ sample['requested_sample.animal_species'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.sample_type']"> {{ sample['requested_sample.sample_type'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.project.name']"> {{ sample['requested_sample.project.name'] }}</td>
            <td v-else> N/A</td>

            <!-- this is the available amount of the sample in the lab -->
            <td v-if="sample['requested_sample.amount']"> {{ sample['requested_sample.amount'] }}</td>
            <td v-else> N/A</td>

            <!-- this is the requested amount-->
            <td v-if="sample.amount"> {{ sample.amount }}</td>
            <td v-else> N/A</td>

            <td>
              <approved-amount-switch :index="index" :item="batchSamples[index]">
              </approved-amount-switch>
            </td>
            &nbsp;
          </tr>
          </tbody>
        </table>

        <!--Notes-->
        <div v-if="this.batchSamples.length !== 0" class="form-group">
          <label for="description">Notes: (Quick response to the requester)</label>
          <textarea class="form-control" id="description" name="description"
                type="text"
                v-model="notes"/>
        </div>

        <!-- COMPLETE REQUEST BUTTON  -->
        <div class="d-flex justify-content-end" v-if="this.batchSamples.length !== 0">
          <b-button size="md" variant="primary" style="border-radius: 50%"
                    v-b-modal.modal-sample-request
                    @click="respondToBatchRequest(batchSamples, self, notes, responsePath)">Respond
          </b-button>
        </div>

        <!-- DIV TO SHOW WHEN USER IS UNAUTHORIZED TO ACCESS  -->
        <div class="d-flex justify-content-center" v-else-if="unauthorized_text !== ''">
          <h2>{{ this.unauthorized_text }}</h2>
        </div>

        <!-- DIV TO SHOW WHEN THERE ARE NO ITEMS IN THE CART -->
        <div class="d-flex justify-content-center" v-else-if="this.batchSamples.length === 0">
          <h2>No sample requests available!</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {batch_sample_response_resource} from "@/utils/api_paths";
import {
  handleError,
  secureStoreGetAuthString,
  startLoader, respondToBatchRequest
} from "@/utils/util_functions";
import axios from "axios";
import TopNav from "@/components/TopNav";
import {font_scale} from "@/utils/constants";
import EventBus from "@/components/EventBus";
import ApprovedAmountSwitch from "@/components/ApprovedAmountSwitch";


export default {
  name: "BatchSampleRequestResponse",
  data(){
    return {
      page_title: "Batch Sample Request Response",
      responsePath: null,
      batchSamples: [], notes: '', batchSamplesResponse: [],
      search: null,
      font_scale,
      unauthorized_text:'',
      self: this,
    }
  },
  mounted() {
    EventBus.$on('new-div-data', payload => {
      let index = payload['index']
      if (this.batchSamples[index] !== undefined){
        this.batchSamples[index].approved_amount = payload['cellValue']

        if (this.batchSamples[index].approved_amount > this.batchSamples[index].amount){
          this.batchSamples[index].approved_amount = 0

          // set error on the div
          document.getElementById('input_'+index).textContent = 'value is greater than available amount';
          document.getElementById('input_'+index).style.backgroundColor = 'red';
        }
      }
    })

    EventBus.$on('unauthorized-access', payload =>{
      this.unauthorized_text = payload
    })
  },

  methods: {
    // util functions
    respondToBatchRequest,

    getRequestedSamples: function (path){
      let loader = startLoader(this)

      axios.get(path, {
        headers: {
          Authorization: secureStoreGetAuthString()
        }
      })
        .then((response) => {
          setTimeout(() => {
            loader.hide()

            if (response.status === 200){
              this.batchSamples = response.data.message
            }
          })
        })
        .catch((error) => {
            handleError(this, error, loader)
        })
    },
  },

  components: {TopNav, ApprovedAmountSwitch},

  created() {
    this.responsePath = batch_sample_response_resource.concat(this.$router.currentRoute.params.pathMatch)
    this.getRequestedSamples(this.responsePath)
  }
}
</script>